var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.44,639.44l-73.18-143.82v143.67H175.5l0.17-219.54h34.6l92.05,182.5l91.06-183.7h34.44V639h-34.44V495.62 l-72.02,143.82H283.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.41,639.14L582.44,420.5h26.32l118.04,218.8h-38.74l-24.83-46.9l-16.06-29.87l-51.99-93.19l-92.05,169.81H463.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.19,420.2h38.74L839.89,639h-26.32L694.53,420.35h39.73l92.05,169.81L919.19,420.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 997.34,
    y: 419.9,
    width: 34.43,
    height: 219.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1101.64,
    y: 419.9,
    width: 34.43,
    height: 219.39
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1369.18,587.77V419.75h34.6v219.39h-34.93l-137.91-166.22v166.22h-35.76V419.75h32.95L1369.18,587.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.15,451.11h-131.29c-16.56,0.1-24.83,8.27-24.83,24.49v109.47c-0.11,15.23,8.77,22.85,26.65,22.85h129.3l0.17,31.36 l-139.23-0.15c-34.66,0.1-51.99-15.53-51.99-46.9l0.17-125.45c0-31.46,17.27-47.19,51.82-47.19h139.07L1647.15,451.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1710.06,
    y: 419.9,
    width: 34.44,
    height: 219.39
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logo_name.add872c3b520f1f4b93c80b85a107425.svg";
export { ForwardRef as ReactComponent };